module.exports = __webpack_public_path__ + "static/media/19.e8418ce8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/19.jpg
// module id = 194
// module chunks = 0